import { XMarkIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import Drawer from "../commons/Drawer";
import { InformationCircleIcon } from "@heroicons/react/16/solid";
import BotLogo from "../commons/BotLogo";
import { normalizeBotName } from "../../utils";

const STRATEGIES = {
  REBALANCE: "rebalance",
  GRID: "grid",
  XENO_ARC: "xeno arc",
  XENO_V3: "xeno bot v3",
  DCA: "dca",
};

const botDetails = {
  [STRATEGIES.REBALANCE]: {
    description: "text1",
    iconColor: "bg-blue-200", // Example color
  },
  [STRATEGIES.DCA]: {
    description:
      "The DCA bot spreads your investment over time with scheduled buys, reducing the impact of market volatility.",
    iconColor: "bg-green-200", // Example color
  },
  [STRATEGIES.XENO_ARC]: {
    description:
      "An upgraded Grid strategy with smarter timing. Xenoarc filters trades by waiting for bounce or reversal signals—reducing noise, avoiding bad entries, and boosting precision in volatile markets.",
    iconColor: "bg-[#B2B7DE]",
  },
  [STRATEGIES.GRID]: {
    description:
      "A classic strategy for profiting from price swings. It places buy and sell orders in a grid to capture gains from small moves—up or down. Best for sideways markets, with steady, stress-free automation.",
    iconColor: "bg-[#FAC482]",
  },
  // Add other strategies here
};

const DrawerActivateBot1Demo = ({
  open,
  onClose,
  onNext,
  setSelectedBot,
  bots,
}) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleNext = (bot) => {
    setSelectedBot(bot);
    onNext();
  };

  return (
    <Drawer open={open} onClose={onClose} width="600px">
      <div className="flex h-full flex-col justify-between">
        <div>
          <header className="relative flex items-center justify-center">
            <h2 className="text-xl font-bold">Activate Bot</h2>
            <button
              type="button"
              className="absolute right-0 bg-transparent text-black hover:bg-transparent"
              onClick={onClose}
              aria-label="Close"
            >
              <XMarkIcon className="h-[18px] w-[18px]" />
            </button>
          </header>

          <div className="bg-[#8BC3FF26] gap-3 p-3 rounded-[10px] border border-[#007AFF] flex items-center mt-6">
            <InformationCircleIcon className="w-full max-w-[16px] h-[16px] text-[#007AFF]" />
            <span className=" text-sm text-[#21272A]/60">
              <strong>Trade Bot with USDT</strong> – make sure your exchange
              balance is in USDT.
            </span>
          </div>

          <div className="mt-5 space-y-5">
            {bots.map((bot, index) => {
              const botNameLower = bot.bot_name?.toLowerCase();
              const details = botDetails[botNameLower] || {
                description: "",
                iconColor: "bg-gray-200",
              };

              return (
                <div
                  key={index}
                  className={`flex hover:bg-[#98F5F31A] cursor-default flex-col items-start  rounded-[10px] border border-[#DDE1E6] p-4 bg-white`}
                  // onClick={() => setActiveIndex(index)}
                  onKeyDown={(e) => e.key === "Enter" && setActiveIndex(index)}
                  role="button"
                  tabIndex={0}
                >
                  <div className="flex items-center gap-2 w-full">
                    <BotLogo botName={botNameLower} />
                    <h4 className="text-base font-bold uppercase">
                      {normalizeBotName(bot.bot_name)}
                    </h4>
                  </div>
                  <div>
                    <p className="text-sm text-[#697077]">
                      {details.description}
                    </p>
                    <div className="flex justify-end">
                      <button
                        onClick={() => {
                          setActiveIndex(index);
                          handleNext(bot);
                        }}
                        className="bg-[#007A78] hover:bg-teal-600 text-white py-2 px-5 md:py-2.5 md:px-6 rounded-lg shadow hover:shadow-md transition-all duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-teal-400 focus:ring-opacity-60 text-sm cursor-pointer"
                      >
                        Activate The Bot
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* <div className="mt-5">
          <button
            type="button"
            className="relative w-full overflow-hidden !bg-[#007A78] !py-3 !text-lg !font-bold"
            onClick={handleNext}
          >
            Next
          </button>
        </div> */}
      </div>
    </Drawer>
  );
};

export default DrawerActivateBot1Demo;
